import styled from 'styled-components'

import { Image, WorkspaceLogo } from '@sketch/components'

import { PREVIEW_SIZE } from '../InboxListItem.styles'

export const SubjectPreviewImage = styled(Image).attrs({ objectFit: 'cover' })`
  width: ${PREVIEW_SIZE}px;
  height: ${PREVIEW_SIZE}px;
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  border-radius: 8px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.canvas.A};
`

export const SubjectFolderGrid = styled.div`
  position: relative;
  box-sizing: border-box;
  width: ${PREVIEW_SIZE}px;
  height: ${PREVIEW_SIZE}px;
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  border-radius: 8px;
  padding: 2px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 2px;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.background.tertiary.C};
`

export const SubjectFolderTile = styled.div`
  min-width: 0;
  min-height: 0;
  border-radius: 6px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.background.secondary.C};
`

export const SubjectFolderImage = styled(Image)`
  width: 100%;
  height: 100%;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border: 1px solid ${({ theme }) => theme.colors.border.A};
    border-radius: 6px;
    box-sizing: border-box;
    pointer-events: none;
  }
`

export const SubjectFolderIcon = styled.div`
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  opacity: 0.3;

  > svg {
    width: 12px;
    height: 12px;
    display: block;
  }
`

export const SubjectWorkspaceLogo = styled(WorkspaceLogo)`
  width: ${PREVIEW_SIZE}px;
  height: ${PREVIEW_SIZE}px;
  border-radius: 8px;

  &::after {
    border-radius: 8px;
  }
`
